/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PepsiCo Geospatial UAV API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetTrialsGeoByLocationParams,
  HTTPValidationError,
  TrialGeoCreate,
  TrialGeoResponse,
  TrialGeoUpdate,
} from "../model";

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getTrialsGeoByLocationResponse200 = {
  data: TrialGeoResponse[];
  status: 200;
};

export type getTrialsGeoByLocationResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getTrialsGeoByLocationResponseSuccess =
  getTrialsGeoByLocationResponse200 & {
    headers: Headers;
  };
export type getTrialsGeoByLocationResponseError =
  getTrialsGeoByLocationResponse422 & {
    headers: Headers;
  };

export type getTrialsGeoByLocationResponse =
  getTrialsGeoByLocationResponseSuccess | getTrialsGeoByLocationResponseError;

export const getGetTrialsGeoByLocationUrl = (
  params: GetTrialsGeoByLocationParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/trials-geo/?${stringifiedParams}`
    : `/api/trials-geo/`;
};

/**
 * @summary Get Trials Geo By Location Route
 */
export const getTrialsGeoByLocation = async (
  params: GetTrialsGeoByLocationParams,
  options?: RequestInit,
): Promise<getTrialsGeoByLocationResponse> => {
  const res = await fetch(getGetTrialsGeoByLocationUrl(params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getTrialsGeoByLocationResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getTrialsGeoByLocationResponse;
};

export const getGetTrialsGeoByLocationQueryKey = (
  params?: GetTrialsGeoByLocationParams,
) => {
  return [`/api/trials-geo/`, ...(params ? [params] : [])] as const;
};

export const getGetTrialsGeoByLocationQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrialsGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params: GetTrialsGeoByLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrialsGeoByLocation>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTrialsGeoByLocationQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTrialsGeoByLocation>>
  > = ({ signal }) =>
    getTrialsGeoByLocation(params, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrialsGeoByLocation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTrialsGeoByLocationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrialsGeoByLocation>>
>;
export type GetTrialsGeoByLocationQueryError = HTTPValidationError;

export function useGetTrialsGeoByLocation<
  TData = Awaited<ReturnType<typeof getTrialsGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params: GetTrialsGeoByLocationParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrialsGeoByLocation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrialsGeoByLocation>>,
          TError,
          Awaited<ReturnType<typeof getTrialsGeoByLocation>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrialsGeoByLocation<
  TData = Awaited<ReturnType<typeof getTrialsGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params: GetTrialsGeoByLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrialsGeoByLocation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrialsGeoByLocation>>,
          TError,
          Awaited<ReturnType<typeof getTrialsGeoByLocation>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrialsGeoByLocation<
  TData = Awaited<ReturnType<typeof getTrialsGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params: GetTrialsGeoByLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrialsGeoByLocation>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Trials Geo By Location Route
 */

export function useGetTrialsGeoByLocation<
  TData = Awaited<ReturnType<typeof getTrialsGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params: GetTrialsGeoByLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrialsGeoByLocation>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTrialsGeoByLocationQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createTrialGeoResponse200 = {
  data: TrialGeoResponse;
  status: 200;
};

export type createTrialGeoResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createTrialGeoResponseSuccess = createTrialGeoResponse200 & {
  headers: Headers;
};
export type createTrialGeoResponseError = createTrialGeoResponse422 & {
  headers: Headers;
};

export type createTrialGeoResponse =
  createTrialGeoResponseSuccess | createTrialGeoResponseError;

export const getCreateTrialGeoUrl = () => {
  return `/api/trials-geo/`;
};

/**
 * @summary Create Trial Geo Route
 */
export const createTrialGeo = async (
  trialGeoCreate: TrialGeoCreate,
  options?: RequestInit,
): Promise<createTrialGeoResponse> => {
  const res = await fetch(getCreateTrialGeoUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(trialGeoCreate),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createTrialGeoResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as createTrialGeoResponse;
};

export const getCreateTrialGeoMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTrialGeo>>,
    TError,
    { data: TrialGeoCreate },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTrialGeo>>,
  TError,
  { data: TrialGeoCreate },
  TContext
> => {
  const mutationKey = ["createTrialGeo"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTrialGeo>>,
    { data: TrialGeoCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createTrialGeo(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTrialGeoMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTrialGeo>>
>;
export type CreateTrialGeoMutationBody = TrialGeoCreate;
export type CreateTrialGeoMutationError = HTTPValidationError;

/**
 * @summary Create Trial Geo Route
 */
export const useCreateTrialGeo = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTrialGeo>>,
      TError,
      { data: TrialGeoCreate },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createTrialGeo>>,
  TError,
  { data: TrialGeoCreate },
  TContext
> => {
  return useMutation(getCreateTrialGeoMutationOptions(options), queryClient);
};
export type updateTrialGeoResponse200 = {
  data: TrialGeoResponse;
  status: 200;
};

export type updateTrialGeoResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateTrialGeoResponseSuccess = updateTrialGeoResponse200 & {
  headers: Headers;
};
export type updateTrialGeoResponseError = updateTrialGeoResponse422 & {
  headers: Headers;
};

export type updateTrialGeoResponse =
  updateTrialGeoResponseSuccess | updateTrialGeoResponseError;

export const getUpdateTrialGeoUrl = (trialGeoId: number) => {
  return `/api/trials-geo/${trialGeoId}`;
};

/**
 * @summary Update Trial Geo Route
 */
export const updateTrialGeo = async (
  trialGeoId: number,
  trialGeoUpdate: TrialGeoUpdate,
  options?: RequestInit,
): Promise<updateTrialGeoResponse> => {
  const res = await fetch(getUpdateTrialGeoUrl(trialGeoId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(trialGeoUpdate),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateTrialGeoResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as updateTrialGeoResponse;
};

export const getUpdateTrialGeoMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTrialGeo>>,
    TError,
    { trialGeoId: number; data: TrialGeoUpdate },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTrialGeo>>,
  TError,
  { trialGeoId: number; data: TrialGeoUpdate },
  TContext
> => {
  const mutationKey = ["updateTrialGeo"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTrialGeo>>,
    { trialGeoId: number; data: TrialGeoUpdate }
  > = (props) => {
    const { trialGeoId, data } = props ?? {};

    return updateTrialGeo(trialGeoId, data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTrialGeoMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTrialGeo>>
>;
export type UpdateTrialGeoMutationBody = TrialGeoUpdate;
export type UpdateTrialGeoMutationError = HTTPValidationError;

/**
 * @summary Update Trial Geo Route
 */
export const useUpdateTrialGeo = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTrialGeo>>,
      TError,
      { trialGeoId: number; data: TrialGeoUpdate },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateTrialGeo>>,
  TError,
  { trialGeoId: number; data: TrialGeoUpdate },
  TContext
> => {
  return useMutation(getUpdateTrialGeoMutationOptions(options), queryClient);
};
export type deleteTrialGeoResponse200 = {
  data: TrialGeoResponse;
  status: 200;
};

export type deleteTrialGeoResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteTrialGeoResponseSuccess = deleteTrialGeoResponse200 & {
  headers: Headers;
};
export type deleteTrialGeoResponseError = deleteTrialGeoResponse422 & {
  headers: Headers;
};

export type deleteTrialGeoResponse =
  deleteTrialGeoResponseSuccess | deleteTrialGeoResponseError;

export const getDeleteTrialGeoUrl = (trialGeoId: number) => {
  return `/api/trials-geo/${trialGeoId}`;
};

/**
 * Soft-clear the trial name and record ``user_id`` (row is kept).
 * @summary Delete Trial Geo Route
 */
export const deleteTrialGeo = async (
  trialGeoId: number,
  options?: RequestInit,
): Promise<deleteTrialGeoResponse> => {
  const res = await fetch(getDeleteTrialGeoUrl(trialGeoId), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteTrialGeoResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as deleteTrialGeoResponse;
};

export const getDeleteTrialGeoMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTrialGeo>>,
    TError,
    { trialGeoId: number },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTrialGeo>>,
  TError,
  { trialGeoId: number },
  TContext
> => {
  const mutationKey = ["deleteTrialGeo"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTrialGeo>>,
    { trialGeoId: number }
  > = (props) => {
    const { trialGeoId } = props ?? {};

    return deleteTrialGeo(trialGeoId, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTrialGeoMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTrialGeo>>
>;

export type DeleteTrialGeoMutationError = HTTPValidationError;

/**
 * @summary Delete Trial Geo Route
 */
export const useDeleteTrialGeo = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTrialGeo>>,
      TError,
      { trialGeoId: number },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTrialGeo>>,
  TError,
  { trialGeoId: number },
  TContext
> => {
  return useMutation(getDeleteTrialGeoMutationOptions(options), queryClient);
};
